export default __webpack_public_path__ + "static/media/endRound15.84867a73.mp3";